// Ashish Nagpal
import React from 'react'
import '../../../stylesheets/book-library.css'

export const LibraryBackground = () => {
  return (
    <>
    <div className="background">
        <div className="overlay"></div>
        <div className="content">
          <h1>Book Library</h1>
        </div>
      </div>
      </>
  )
}
